import React, { FunctionComponent } from 'react';
import { Skeleton } from '@doveit/lego';

import * as styles from './PropertyCard.style';

export const PropertyCardSkeleton: FunctionComponent = () => (
  <article css={styles.basic}>
    <div css={styles.content}>
      <div css={styles.info}>
        <div css={styles.title}>
          <Skeleton />
        </div>
        <div css={styles.price}>
          <Skeleton width="100px" />
        </div>
        <div css={styles.description}>
          <Skeleton count={3} width="80%" />
        </div>
        <div css={styles.actions}>
          <Skeleton height="30px" width="200px" />
        </div>
      </div>
      <div css={styles.preview}>
        <Skeleton height="200px" />
      </div>
    </div>
  </article>
);

export default PropertyCardSkeleton;
